<!-- 进场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
              "carLicenseNumber": "",
              "customer": "",
              "expireTime": "20240808235959",
              "monthTicketConfigId": 1200000,
              "msg": "",
              "openId": "",
              "parkCode": "",
              "source": "vos",
              "status": "REVIEWED_NOT_PASSED",
              "time": "20230808000000"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报月票凭证变更信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportMonthTicketCertificateChanges",
                precondition: "无",
                fitSystem: "云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'customer', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'msg', info2: '是', info3: 'String', info4: '消息' },
                        { info1: 'time', info2: '否', info3: 'String', info4: '时间，YYYYMMddHHmmss' },
                        { info1: 'openId', info2: '是', info3: 'String', info4: '用户微信openId' },
                        { info1: 'status', info2: '是', info3: 'String', info4: '凭证状态：REVIEWED_PASSED 审核通过 REVIEWED_NOT_PASSED 审核不通过 TIME_EXPIRED 凭证过期' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                        { info1: 'expireTime', info2: '否', info3: 'String', info4: '到期时间，YYYYMMddHHmmss格式' },
                        { info1: 'source', info2: '否', info3: 'String', info4: '来源，vos或授权商key' },

                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportMonthTicketCertificateChanges.vue